import { SectionTitle } from "../../design-system/title"
import { CurrentSaleRoundForBuy, ListActiveSaleRoundsForUser } from "../round/sale/sale-round"
import { UserInvestments } from "../round/user-investments"
import { ClaimFromSnapshotComponent } from "./claim-from-snapshot"

export const UserDashboardComponent: React.FC<{}> = () => {
    return (
        <div>
            <div className="mb-8">
                <CurrentSaleRoundForBuy />
            </div>
        </div>
    )
}
